<template>
  <div class="bind-email-container">
    <change-box class="change-box">
      <template v-slot:content>
        <el-form :model="emilForm"
                 status-icon
                 :rules="emailRules"
                 ref="emilFormRef">
          <el-form-item prop="emailAddress">
            <h3 class="title">
              绑定邮箱账号
            </h3>
            <el-input placeholder="邮箱"
                      v-model="emilForm.emailAddress"
                      class="new-emil"
                      autocomplete="off"
                      clearable
                      size="small"></el-input>
          </el-form-item>
          <slide-validation class="validation"
                            @verifySuccess="verifySuccess"></slide-validation>
          <el-form-item prop="verifyCode"
                        class="code-wrapper">
            <el-input placeholder="验证码"
                      v-model="emilForm.verifyCode"
                      size="small"></el-input>
            <div :class="[{'is-disabled': isDisabled},'get-code-btn']"
                 @click="getCode"
                 v-if="!isSentCode">获取验证码</div>
            <div class="regain-code"
                 v-if="isSentCode">重新获取({{ countDown }})</div>
          </el-form-item>
          <div class="btn-group">
            <el-button type="primary"
                       size="small"
                       @click="submitemilForm">确认</el-button>
            <el-button size="small"
                       @click="goBack">返回</el-button>
          </div>
        </el-form>
      </template>
    </change-box>
  </div>
</template>

<script>
import changeBox from '@/components/public/changeBox'
import slideValidation from '@/components/public/slideValidation'
export default {
  components: {
    'change-box': changeBox,
    'slide-validation': slideValidation
  },
  data () {
    let validateEmail = (rule, value, callback) => {
      if (value.trim() === '') {
        this.emailValidatePass = false
        callback(new Error('请输入邮箱'));
      } else {
        let reg = /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/
        if (!reg.test(value)) {
          this.emailValidatePass = false
          callback(new Error('请输入正确的邮箱'))
        } else {
          this.emailValidatePass = true
          callback();
        }
      }
    };
    return {
      emilForm: {
        emailAddress: '',
        verifyCode: ''
      },
      emailRules: {
        emailAddress: [
          { validator: validateEmail, trigger: ['blur', 'change'] }
        ],
        emailCode: [
          { pattern: /^[0-9]{6}$/, message: '请输入正确的验证码', trigger: 'blur' },
        ]
      },
      // 手机号验证成功
      emailValidatePass: false,
      // 滑块验证成功
      slideValidatePass: false,
      isDisabled: true,
      countDown: 60,
      isSentCode: false,
      timer: 0
    };
  },
  watch: {
    emailValidatePass () {
      this.isDisabled = !(this.emailValidatePass && this.slideValidatePass)
    },
    slideValidatePass () {
      this.isDisabled = !(this.emailValidatePass && this.slideValidatePass)
    },
    countDown (newval) {
      if (newval < 1) {
        clearInterval(this.timer)
        this.isSentCode = false
        this.countDown = 60
      }
    }
  },
  created () {
  },
  methods: {
    verifySuccess () {
      this.slideValidatePass = true
    },
    getCode () {
      if (this.isDisabled) {
        return false
      } else {
        let emailAddress = this.emilForm.emailAddress
        this.$http.post('/api/services/inquiryApp/account/ModifyEmailSender?emailAddress=' + emailAddress)
          .then(res => {
            if (res.success) {
              this.$message.success('验证码发送成功，5分钟内有效！')
              this.isSentCode = true
              this.countDown = 60
              this.timer = setInterval(() => {
                this.countDown--
              }, 1000);
            }
          })
          .catch(err => {
            this.$message.error(err.data.error.message)
          })
      }
    },
    submitemilForm () {
      this.$refs.emilFormRef.validate((valid) => {
        if (valid) {
          this.$http.put('/api/services/inquiryApp/account/ModifyEmail', this.emilForm)
            .then(res => {
              this.$message.success('绑定邮箱成功！')
              this.$router.go(-1)
            })
            .catch(err => {
              this.$message.error(err.data.error.message)
            })
        } else {
          return false;
        }
      });
    },
    goBack () {
      this.$router.go(-1)
    }
  },
};
</script>
<style lang="less" scoped>
.bind-email-container {
  background-color: #f4f4f4;
  height: 100%;
  padding-top: 50px;
  font-family: 'Source Han Sans CN';
}
.change-box {
  margin: 0 auto;
  text-align: center;
  .el-form-item {
    width: 256px;
    margin: 0 auto 20px;
    // margin-bottom: 0;
  }
  .title {
    text-align: center;
    color: #2f343c;
    margin-bottom: 20px;
  }
  .new-email {
    width: 256px;
  }
  .validation {
    width: 256px;
    margin: 0 auto 20px;
  }
  .code-wrapper {
    width: 256px;
    height: 32px;
    margin: 0 auto;
    /deep/ .el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .get-code-btn {
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      white-space: nowrap;
      padding: 0 5px;
      background-color: #027cff;
      color: #ffffff;
      border-radius: 3px;
      cursor: pointer;
      margin-left: 20px;
      user-select: none;
    }
    .is-disabled {
      background-color: #eeeeee;
      color: #bbbbbb;
    }
    .regain-code {
      height: 32px;
      margin-left: 20px;
      line-height: 32px;
      font-size: 12px;
      background: #cccccc;
      border-radius: 3px;
      white-space: nowrap;
      color: #ffffff;
      user-select: none;
      cursor: not-allowed;
    }
  }
  .btn-group {
    width: 256px;
    margin: 20px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button {
      width: 115px;
    }
  }
}
</style>